const zipCode = /^\d{5}(-\d{4})?$/

export default zipCode;
